import { render, staticRenderFns } from "./viewWorks.vue?vue&type=template&id=73c7f018"
import script from "./viewWorks.vue?vue&type=script&lang=js"
export * from "./viewWorks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73c7f018')) {
      api.createRecord('73c7f018', component.options)
    } else {
      api.reload('73c7f018', component.options)
    }
    module.hot.accept("./viewWorks.vue?vue&type=template&id=73c7f018", function () {
      api.rerender('73c7f018', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/education/viewWorks.vue"
export default component.exports